export default __webpack_public_path__ + "static/media/Roxana Terrazas.92bed18b.jpg";